// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import { getToken } from '@/utils/auth';
import 'element-ui/lib/theme-chalk/index.css';


Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.path === '/login') {
    next();
  } else {
    if (token) {
      next();
    } else {
      next('/login');
    }
  }

});

Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js